import { render, staticRenderFns } from "./IslemlerView.vue?vue&type=template&id=459b49c4"
import script from "./IslemlerView.vue?vue&type=script&lang=ts"
export * from "./IslemlerView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports